export default {
  state: {
    models: [
      {
        type: 'polo', // тип изделия
        model: 'muzhskaya-polo-korotkij-rukav', // УНИКАЛЬНОЕ, модель
        title: 'Мужская поло короткий рукав', // заголовок
        description: `<p><strong>Плотность:</strong>&nbsp;200-220 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> пике, малоусадочное, кардное</p>
        <p><strong>Размеры:</strong> S-3XL</p>
        <p><strong>Воротник:</strong> планка с 2 пуговицами в тон ткани</p>
        <p><strong>Силуэт:</strong> прямой;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 2500, // минимальная сумма заказа
        colors: ['black', 'red', 'orange', 'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'white',
        image: 'https://pr-tex.ru/wp-content/uploads/white_front.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black_front-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/red_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/red_front-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/orange_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/orange_front-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy_front-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/vasilek_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/vasilek_front-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy_front-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/white_front.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/white_front-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/yelow_face.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/yelow_face-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 5, price: 500 },
          { from: 6, to: 10, price: 450 },
          { from: 11, to: 30, price: 420 },
          { from: 31, to: 50, price: 370 },
          { from: 51, to: 100, price: 340 },
          { from: 101, to: 250, price: 320 },
          { from: 251, to: 500, price: 310 },
          { from: 501, to: 1000, price: 299 },
          { from: 1001, to: 3000, price: 290 },
        ]
      },
      {
        type: 'polo', // тип изделия
        model: 'muzhskaya-polo-dlinnyj-rukav', // УНИКАЛЬНОЕ, модель
        title: 'Мужская поло длинный рукав', // заголовок
        description: `<p><strong>Плотность:</strong>&nbsp;200-210 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> пике, малоусадочное, кардное</p>
        <p><strong>Размеры:</strong> S-2XL</p>
        <p><strong>Воротник:</strong> планка с 2 пуговицами в тон ткани</p>
        <p><strong>Силуэт:</strong> приталенный;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp; Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'green', 'jeans', 'red', 'azure', 'terracotta', 'white'], // доступные цвета
        defaultColor: 'terracotta',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/07/cofee.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/black-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/black-3-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/bordo-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/bordo-3-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/dark-green-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/dark-green-2-100x100.jpg',
          },
          {
            color: 'jeans',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/dark-blue.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/dark-blue-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/red-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/red-1-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/birusa-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/birusa-1-100x100.jpg',
          },
          {
            color: 'terracotta',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/cofee.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/cofee-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/white-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/white-3-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 5, price: 600 },
          { from: 6, to: 10, price: 550 },
          { from: 11, to: 50, price: 520 },
          { from: 51, to: 100, price: 500 },
          { from: 101, to: 250, price: 480 },
          { from: 251, to: 500, price: 460 },
          { from: 501, to: 1000, price: 450 },
          { from: 1001, to: 3000, price: 440 },
        ]
      },
      {
        type: 'polo', // тип изделия
        model: 'muzhskaya-polo-korotkij-rukav-premium', // УНИКАЛЬНОЕ, модель
        title: 'Мужская поло ПРЕМИУМ', // заголовок
        description: `<p><strong>Плотность:</strong>&nbsp;220 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> пике, малоусадочное, кардное</p>
        <p><strong>Размеры:</strong> S-3XL</p>
        <p><strong>Крой:</strong> прямой, с боковыми вырезами и манжетами</p>
        <p><strong>Воротник:</strong> планка с 3 пуговицами в тон ткани</p>
        <p><strong>Силуэт:</strong> прямой;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'dark-green', 'red', 'melange', 'orange', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'red',
        image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_03.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_09-600x600.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_09-100x100.jpg',
          },
          {
            color: 'dark-green',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_07.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_07-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_03.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_03-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_04.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_04-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_05.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_05-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_06.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_06-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_08.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_08-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_01.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_01-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/01/polo-premium_02-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 5, price: 600 },
          { from: 6, to: 10, price: 550 },
          { from: 11, to: 30, price: 500 },
          { from: 31, to: 50, price: 450 },
          { from: 51, to: 100, price: 430 },
          { from: 101, to: 250, price: 410 },
          { from: 251, to: 500, price: 380 },
          { from: 501, to: 1000, price: 370 },
          { from: 1001, to: 3000, price: 360 },
        ]
      },
      {
        type: 'polo', // тип изделия
        model: 'zhenskaya-polo-korotkij-rukav', // УНИКАЛЬНОЕ, модель
        title: 'Женская поло короткий рукав', // заголовок
        description: `<p><strong>Плотность:</strong>&nbsp;200-210 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> пике, малоусадочное, кардное</p>
        <p><strong>Размеры:</strong> S-2XL</p>
        <p><strong>Воротник:</strong> планка с 2 пуговицами в тон ткани</p>
        <p><strong>Силуэт:</strong> приталенный;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'female', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'dark-green', 'cyan', 'mustard', 'red', 'azure', 'sky',
                 'orange', 'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'yellow',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/07/limon.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/black-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/black-2-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/bordo-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/bordo-2-100x100.jpg',
          },
          {
            color: 'dark-green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-zeleniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-zeleniy-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-goluboy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-goluboy-100x100.jpg',
          },
          {
            color: 'mustard',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/yellow.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/yellow-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/red.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/red-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/birusa.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/birusa-100x100.jpg',
          },
          {
            color: 'sky',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/blue.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/blue-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/orange-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/orange-2-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/seriy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/seriy-2-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/siniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/siniy-2-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-siniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/temno-siniy-2-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/white-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/white-2-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/07/limon.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/07/limon-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 5, price: 500 },
          { from: 6, to: 10, price: 450 },
          { from: 11, to: 50, price: 420 },
          { from: 51, to: 100, price: 400 },
          { from: 101, to: 250, price: 380 },
          { from: 251, to: 500, price: 360 },
          { from: 501, to: 1000, price: 350 },
          { from: 1001, to: 3000, price: 340 },
        ]
      },
    ]
  }
}